import { css } from '@emotion/react'
import { memo } from 'react'
import { openLoungesDrawer } from '../../app-state/modals/state.drawer'
import { isLevelPremiumOrHigher } from '../../mfcLogic/userProperties/level'
import { routerPush } from '../../utilities/router'
import { AppStateType, useAppStateSelector } from '../Hooks/useAppState'
import { useUserSelector } from '../Hooks/useUser'
import { getThemeSpacing } from '../styles/appTheme'
import { palette } from '../styles/colors'
import Link from './Link'

const rootStyles = css({
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    width: '100%',
    padding: getThemeSpacing(1),
})

const emptyStyles = css({
    fontWeight: 600,
    color: palette.contrastIcons,
    fontSize: 16,
    padding: `0 ${getThemeSpacing(2)}`,
    letterSpacing: '0.13923px', // matching the original mui sizing til we dump typography
    lineHeight: 1.66,
})

export type EmptyProps = {
    before?: string
    after?: string
}

const Empty = (props: EmptyProps) => {
    const { before = '', after = '' } = props
    const onExplore = () => {
        routerPush('/search')
    }
    const authenticated = useAppStateSelector(AppStateType.APP, 'authenticated')
    const level = useUserSelector('me', 'level')
    const isPremium = isLevelPremiumOrHigher(level)

    return (
        <div css={rootStyles}>
            <span
                css={emptyStyles}
                className="centered"
                data-testid="Empty__LinkContainer"
            >
                {before} <br />
                <span data-testid="Home__Link">
                    <Link page="home" inline mfc>
                        Visit the Homepage
                    </Link>
                </span>
                {authenticated && isPremium && (
                    <span data-testid="Lounge__Link">
                        ,{' '}
                        <Link onClick={openLoungesDrawer} actionLink mfc>
                            Visit the Lounges
                        </Link>
                    </span>
                )}{' '}
                or{' '}
                <span data-testid="Search__Link">
                    <Link onClick={onExplore} actionLink mfc>
                        Explore Online Models
                    </Link>{' '}
                </span>
                {after}
            </span>
        </div>
    )
}

export default memo(Empty)
